const projects = [
    {
    id:4,
    titleEng: 'Customer Sentiment Analyser 📈',
    titleEsp: 'Analizador de Sentimiento de Clientes 📈',
    contentEng: 'Analysis tool for cutomer feedback using LangChain and Claude. Backend in Python (Django) and frontend in JavaScript (React).',
    contentEsp: 'Análisis de comentarios de clientes usando LangChain y Claude. Backend en Python (Django) y frontend en JavaScript (React).',
    site: 'https://sentiment-dashboard.netlify.app/',
    gitHub: 'https://github.com/BuenVia/sentiment-dash-backend',
    __v: 0,
  },
  {
    id:3,
    titleEng: 'Spotify Profiler 🎵',
    titleEsp: 'Analizador de Spotify 🎵',
    contentEng: 'Using the Spotify API, profiles artists and the releases. Backend built in Python (FastAPI) and run as Docker deploy on Render.com. Frontend in JavaScript (React).',
    contentEsp: 'Usando la API de Spotify, perfila artistas y sus lanzamientos. Backend construido en Python (FastAPI) y ejecutado como despliegue Docker en Render.com. Frontend en JavaScript (React).',
    site: 'https://spotify-profiler-0fyj.onrender.com',
    gitHub: 'https://github.com/BuenVia/spotify-profiler',
    __v: 0,
  },
  {
    id:2,
    titleEng: 'OpenAI Translate Tool ↔️',
    titleEsp: 'OpenAI Herramienta de traducción ↔️',
    contentEng: 'Translation tool (English -> Spanish, French or Japanese) using OpenAI\'s gpt-4 API.',
    contentEsp: 'Herramienta de traducción (inglés -> español, francés, japonés) con la API gpt-4 de OpenAI.',
    site: 'https://translateai.pages.dev/',
    gitHub: 'https://github.com/BuenVia/translateai',
    __v: 0,
  },
  {
    id:1,
    titleEng: "VerbApps 🗣️ ",
    titleEsp: "VerbApps 🗣️ ",
    contentEng: "A language learning app for practicing Spanish verb conjugations. Built with HTML, CSS and JS.",
    contentEsp: "Una programa para practicar las conjugaciones en español. Programado en HTML, CSS y JS",
    site: "https://verbapp.netlify.app/",
    gitHub: "https://github.com/BuenVia/VerbApp",
    __v: 0,
  }
  ]

  export default projects